import React from 'react';
import { Bell, Sparkles } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext.js';

interface HeaderProps {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
}

export const Header: React.FC<HeaderProps> = ({ title, subtitle, action }) => {
  const { user } = useAuth();

  return (
    <header className="h-20 bg-surface border-b border-bdr px-8 flex items-center justify-between sticky top-0 z-20">
      <div>
        <h1 className="text-xl font-bold text-txt-primary flex items-center gap-2">
          {title}
        </h1>
        {subtitle && (
          <p className="text-xs text-txt-secondary mt-0.5">{subtitle}</p>
        )}
      </div>

      <div className="flex items-center gap-4">
        {action}

        {/* Tenant Plan Badge */}
        <div className="hidden md:flex items-center gap-1.5 px-3 py-1 bg-brand-light text-brand-primary border border-orange-200 rounded-full text-xs font-semibold">
          <Sparkles size={14} />
          <span>Plano Ativo</span>
        </div>

        {/* Notifications */}
        <button
          className="p-2 text-txt-secondary hover:text-txt-primary hover:bg-surface-secondary rounded-lg transition-colors relative"
          title="Notificações"
        >
          <Bell size={18} />
          <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-brand-primary rounded-full ring-2 ring-white"></span>
        </button>

        {/* User Avatar */}
        <div className="flex items-center gap-2.5 pl-2 border-l border-bdr">
          <div className="w-8 h-8 rounded-full bg-brand-primary text-white flex items-center justify-center font-bold text-xs shadow-sm">
            {user?.fullName?.charAt(0) || 'C'}
          </div>
          <div className="hidden lg:block text-left leading-tight">
            <span className="block text-xs font-semibold text-txt-primary">
              {user?.fullName || 'Cliente EduRender'}
            </span>
            <span className="block text-[10px] text-txt-secondary">
              Ambiente Cliente
            </span>
          </div>
        </div>
      </div>
    </header>
  );
};
